import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const ClockIcon = ({ width = 14, height = 14 }) => (
  <SvgIcon sx={{ width, height }} viewBox="0 0 14 14">
    <path
      d="M9.55905 10.3357L10.3357 9.55905L7.55263 6.776V3.31579H6.44737V7.22382L9.55905 10.3357ZM7.00129 14C6.03308 14 5.12302 13.8163 4.2711 13.4488C3.41919 13.0814 2.67818 12.5827 2.04805 11.9529C1.41793 11.323 0.919026 10.5823 0.551342 9.73074C0.183781 8.87919 0 7.96938 0 7.00129C0 6.03308 0.183719 5.12302 0.551158 4.2711C0.918596 3.41919 1.41725 2.67818 2.04713 2.04805C2.67701 1.41793 3.41772 0.919026 4.26926 0.551342C5.12081 0.183781 6.03062 0 6.99871 0C7.96692 0 8.87698 0.183719 9.7289 0.551158C10.5808 0.918596 11.3218 1.41725 11.9519 2.04713C12.5821 2.67701 13.081 3.41772 13.4487 4.26926C13.8162 5.12081 14 6.03062 14 6.99871C14 7.96692 13.8163 8.87698 13.4488 9.7289C13.0814 10.5808 12.5827 11.3218 11.9529 11.9519C11.323 12.5821 10.5823 13.081 9.73074 13.4487C8.87919 13.8162 7.96938 14 7.00129 14ZM7 12.8947C8.63333 12.8947 10.0241 12.3206 11.1724 11.1724C12.3206 10.0241 12.8947 8.63333 12.8947 7C12.8947 5.36667 12.3206 3.97588 11.1724 2.82763C10.0241 1.67939 8.63333 1.10526 7 1.10526C5.36667 1.10526 3.97588 1.67939 2.82763 2.82763C1.67939 3.97588 1.10526 5.36667 1.10526 7C1.10526 8.63333 1.67939 10.0241 2.82763 11.1724C3.97588 12.3206 5.36667 12.8947 7 12.8947Z"
      fill="#747487"
    />
  </SvgIcon>
);

ClockIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ClockIcon;
